import { finalize } from 'rxjs';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SpinnerService } from '../core/services/spinner.service';

/**
 * HTTP interceptor for SRP Zuid Configurator
 * - Adds Authorization header with JWT token from sessionStorage
 * - Shows/hides spinner during HTTP requests
 * - Enables credentials for CORS requests
 */
export const appHttpInterceptor: HttpInterceptorFn = (req, next) => {
    const spinnerService = inject(SpinnerService);
    spinnerService.status$.set(true);

    const request = req.clone({
        setHeaders: {
            Authorization: `Bearer ${sessionStorage.getItem('token') ?? ""}`
        },
        withCredentials: true
    });

    return next(request)
        .pipe(finalize(() => spinnerService.status$.set(false)));
};
